import { render, staticRenderFns } from "./stockTransactionDialog.vue?vue&type=template&id=bcbb3d3a&"
import script from "./stockTransactionDialog.vue?vue&type=script&lang=js&"
export * from "./stockTransactionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports